const extensionImages = {
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpeg'
};

const typeExtension = {
  pdf: 'application/pdf',
  image: 'image/'
};

export const FILE_DOWNLOAD_TYPES = {
  ZIP: 1,
  INDIVIDUAL: 2,
  COMBINE_PDF: 3,
  BROWSER: 4
};

export const extensionCanOpenInBrowser = [
  'pdf',
  extensionImages.jpg,
  extensionImages.jpeg,
  extensionImages.png
];

const getContenType = (fileName) => {
  const splitName = fileName.split('.');
  const extName = splitName[splitName.length - 1];
  let typeName = typeExtension.pdf;

  if (extName in extensionImages) {
    typeName = typeExtension.image.concat(extName);
  }

  return {
    type: typeName
  };
};

export const downloadBase64 = (file, fileName, ext) => {
  let type = 'application/pdf';

  // en caso de necesitar otra extensión, buscar Extension MIME Type para saber cual corresponde
  if (ext === 'xlsx') {
    type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }
  const data = `data:${type};base64,${file}`;
  const link = document.createElement('a');

  link.href = data;
  link.download = `${fileName}.${ext || 'pdf'}`;
  link.click();
};

// Si solo se va a descargar un archivo, al pasarle el nombre del archivo,
// no se descargará como .zip
const downloadFiles = (blobData, oneFile = null, downloadType) => {
  const canVisualize =
    !oneFile || downloadType === FILE_DOWNLOAD_TYPES.BROWSER
      ? extensionCanOpenInBrowser.some((ext) => oneFile.toLowerCase().includes(ext.toLowerCase()))
      : false;
  const type = canVisualize ? getContenType(oneFile.toLowerCase()) : null;

  const url = window.URL.createObjectURL(new Blob([blobData], type));

  const link = document.createElement('a');

  link.href = url;
  link.setAttribute(
    'download',
    FILE_DOWNLOAD_TYPES.ZIP === downloadType ? 'download.zip' : oneFile
  );
  document.body.appendChild(link);
  if (type) {
    window.open(url, Math.random());
  } else {
    link.click();
  }
};

export default downloadFiles;
